module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/eventstaff-icon-66c2f14dd416792c7035a4abbbd67286.png";